import React from 'react';
import './ClientAppointmentDetails.css';

const ClientAppointmentDetails = ({ appointment, onClose, onCancelRequest }) => {
  // Formater la durée pour l'affichage
  const formatDuration = (duration) => {
    if (!duration) return '';
    if (duration === 90) return '1h30';
    if (duration === 60) return '1h';
    if (duration === 45) return '45min';
    return `${duration} min`;
  };

  // Vérifier si un rendez-vous peut être annulé (24h avant)
  const canCancelAppointment = (date, time) => {
    const appointmentDate = new Date(`${date}T${time}`);
    const now = new Date();

    // Différence en millisecondes
    const diffTime = appointmentDate - now;
    // Différence en heures
    const diffHours = diffTime / (1000 * 60 * 60);

    // Peut annuler si plus de 24h avant le rendez-vous
    return diffHours > 24;
  };

  const isUpcoming = () => {
    const appointmentDate = new Date(appointment.date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return appointmentDate >= today && appointment.status === 'confirmed';
  };

  return (
    <div className="client-appointment-details-modal">
      <div className="client-appointment-details-content">
        <div className="client-appointment-details-header">
          <h3>Détails du rendez-vous</h3>
          <button
            className="close-modal-btn"
            onClick={onClose}
            aria-label="Fermer"
          >
            &times;
          </button>
        </div>

        <div className="client-appointment-info">
          <div className="info-row">
            <div className="info-label">Date :</div>
            <div className="info-value">{appointment.formattedDate}</div>
          </div>

          <div className="info-row">
            <div className="info-label">Heure :</div>
            <div className="info-value">{appointment.time}</div>
          </div>

          <div className="info-row">
            <div className="info-label">Service :</div>
            <div className="info-value">{appointment.serviceTitle}</div>
          </div>

          <div className="info-row">
            <div className="info-label">Durée :</div>
            <div className="info-value">{formatDuration(appointment.duration)}</div>
          </div>

          <div className="info-row">
            <div className="info-label">Prix :</div>
            <div className="info-value">{appointment.price}€</div>
          </div>

          <div className="info-row">
            <div className="info-label">Type :</div>
            <div className="info-value">
              {appointment.isRemote ? (
                <span className="detail-remote-badge">À distance (téléconsultation)</span>
              ) : (
                <span className="detail-in-person-badge">En présentiel</span>
              )}
            </div>
          </div>

          {/* Section pour le lien de visioconférence (si rendez-vous à distance) */}
          {appointment.isRemote && (
            <div className="client-remote-info-box">
              <h4>Informations sur votre consultation à distance</h4>
              {appointment.meetingLink ? (
                <>
                  <p>Utilisez le lien ci-dessous pour rejoindre votre consultation à distance :</p>
                  <div style={{ textAlign: 'center', margin: '15px 0' }}>
                    <a
                      href={appointment.meetingLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-primary"
                      style={{ display: 'inline-block', marginBottom: '10px' }}
                    >
                      Rejoindre la visioconférence
                    </a>
                  </div>
                  <p className="link-sent-info">Le lien est disponible et prêt à être utilisé</p>
                </>
              ) : (
                <p>Un lien de visioconférence vous sera envoyé par email avant le rendez-vous.</p>
              )}
              <p style={{ marginTop: '10px', fontSize: 'var(--font-size-small)' }}>
                Assurez-vous d'avoir une connexion internet stable et un environnement calme pour votre consultation.
              </p>
            </div>
          )}

          {/* Afficher les notes de service si elles existent */}
          {appointment.serviceNotes && (
            <div className="service-notes-container" style={{ marginTop: '15px' }}>
              <div className="info-label">Informations complémentaires :</div>
              <div className="service-notes" style={{
                whiteSpace: 'pre-line',
                backgroundColor: '#f0f7f3',
                padding: '10px',
                borderRadius: '5px',
                marginTop: '5px',
                borderLeft: '3px solid #3a865f'
              }}>
                {appointment.serviceNotes}
              </div>
            </div>
          )}
        </div>

        <div className="client-appointment-practitioner">
          <h4>Informations sur le praticien</h4>

          <div className="info-row">
            <div className="info-label">Nom :</div>
            <div className="info-value">{appointment.practitionerName}</div>
          </div>

          {appointment.practitioner && appointment.practitioner.phone && (
            <div className="info-row">
              <div className="info-label">Téléphone :</div>
              <div className="info-value">{appointment.practitioner.phone}</div>
            </div>
          )}

          {appointment.practitioner && appointment.practitioner.address && (
            <div className="info-row">
              <div className="info-label">Adresse :</div>
              <div className="info-value">
                {appointment.practitioner.address.street},
                {appointment.practitioner.address.zipCode} {appointment.practitioner.address.city}
              </div>
            </div>
          )}
        </div>

        {appointment.status === 'canceled' && (
          <div className="cancellation-info-panel">
            <h4>Informations sur l'annulation</h4>
            <p>
              Ce rendez-vous a été annulé
              {appointment.canceledBy === 'client' ? ' par vous' : ' par le praticien'}.
            </p>
            {appointment.cancelNote && (
              <p><strong>Raison :</strong> {appointment.cancelNote}</p>
            )}
          </div>
        )}

        <div className="client-appointment-actions">
          {isUpcoming() && (
            canCancelAppointment(appointment.date, appointment.time) ? (
              <button
                className="btn btn-danger"
                onClick={() => onCancelRequest(appointment)}
              >
                Annuler ce rendez-vous
              </button>
            ) : (
              <div className="cancellation-notice-details">
                Annulation impossible à moins de 24h du rendez-vous. Veuillez contacter directement le praticien pour toute demande d'annulation.
              </div>
            )
          )}
          <button className="btn btn-primary" onClick={onClose}>
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClientAppointmentDetails;